module.exports = __webpack_public_path__ + "img/icon.39449576.svg";